import React from "react";
import EditProfile from "../../components/EditProfile";
import Footer from "../../components/Footer";
import NavHeader from "../../components/NavHeader";

export default class AdminSettingsPage extends React.Component {
    render() {
        return <section className="main-content">
                <section className="main-content-body">
                    <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>

                    <EditProfile profileEdit/>
                </section>

                <Footer/>
        </section>;
    }
};
